import styled from '@emotion/styled';
import { Box } from '@mui/material';
import { ContentEditable } from '@lexical/react/LexicalContentEditable';
import { primary } from '_lex/_foundations/phxColors';

export const MuiContentEditable = styled(ContentEditable)({
  minHeight: 200,
  width: '100%',
  padding: '0 8px',
  borderRadius: 5,
  paddingTop: 2,
  paddingLeft: 10,
  position: 'relative',
  outline: 'none',
  '&[contenteditable=false]': {
    minHeight: 0,
    padding: 0,
  },

  '.text-entity': {
    padding: '0px 2px',
    borderRadius: 4,
    backgroundColor: 'rgb(110, 148, 209, 0.2)',
    display: 'inline-flex',
    '&:before': {
      content: '"["',
    },
    '&:after': {
      content: '"]"',
    },
  },
  '.phx-cross-ref-link': {
    color: primary[800],
    display: 'inline-flex',
    textDecoration: 'none',
    '&:hover': {
      textDecoration: 'underline',
    },
  },
});

export const EditorPlaceholder = styled(Box)({
  position: 'absolute',
  top: 15,
  left: 10,
  userSelect: 'none',
  display: 'inline-block',
  pointerEvents: 'none',
});
